export default __webpack_public_path__ + "e3a8f9133df704e20f4394e252c81afd.svg";